import React from "react";
import styled from "styled-components";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import TimelineCard from "./TimelineCard";

const StyledList = styled.ul`
  list-style-type: disc;
`;

const SideBox = styled.div`
  flex: 1;
  font-size: 18px !important;
  color: #000 !important;
  padding: 16px;
  background: #fff;
  height: fit-content;

  @media (max-width: 768px) {
    font-size: 14px !important;
    flex: 100%;
    margin-bottom: 20px;
  }
`;

const TimelineWrapper = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* distribute items evenly */
`;

const RowContainer = styled.div`
  display: flex;
  gap: 20px;
  border: 3px solid #ff8f4e;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 16px;
  background: #fff;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ATLTinkerpreneurTimelineBox = ({
  events,
  isMobile,
  getDotColor,
  category,
  classes,
  onCardClick,
}) => {
  const { t } = useTranslation();
  const categoryData = `atl_tinkerpreneur.${category}`;
  const leftContents = t(`${categoryData}.leftContents`, {
    returnObjects: true,
  });
  const rightContents = t(`${categoryData}.rightContents`, {
    returnObjects: true,
  });
  return (
    <RowContainer>
      <SideBox>
        <h5>{t(`${categoryData}.leftTitle`)}</h5>
        <p>{t(`${categoryData}.leftDescription`)}</p>
        <StyledList>
          {Array.isArray(leftContents) &&
            leftContents.map((item, index) => <li key={index}>{item}</li>)}
        </StyledList>
      </SideBox>
      <TimelineWrapper>
        <Timeline align={isMobile ? "left" : "alternate"}>
          {events.map((item, index) => (
            <TimelineItem key={index} className={classes.timelineItem}>
              <TimelineSeparator className={classes.separator}>
                <TimelineDot
                  className={classes.timelineDot}
                  color={getDotColor(item)}
                  variant={item.status === "Upcoming" ? "outlined" : "default"}
                />
                {index < events.length - 1 && (
                  <TimelineConnector
                    className={
                      item.status === "Completed"
                        ? classes.completedConnector
                        : ""
                    }
                  />
                )}
              </TimelineSeparator>
              <TimelineContent className={classes.timelineContent}>
                <TimelineCard
                  item={item}
                  onClick={(e) => onCardClick && onCardClick(e, item)}
                />
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </TimelineWrapper>
      <SideBox>
        <h5>{t(`${categoryData}.rightTitle`)}</h5>
        <StyledList>
          {Array.isArray(rightContents) &&
            rightContents.map((item, index) => <li key={index}>{item}</li>)}
        </StyledList>
      </SideBox>
    </RowContainer>
  );
};

export default ATLTinkerpreneurTimelineBox;
